import React, { useMemo, useEffect, useState } from 'react';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { formatCurrency } from '../../../utils/helpers';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function InvoiceChart({ data }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 991);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 991);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const options = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,

    layout: {
      padding: {
        left: 10,
        right: 10,
      },
    },

    plugins: {
      legend: {
        position: 'top',
        align: isMobile ? 'end' : 'center',
      },

      title: {
        display: false,
      },

      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            if (label) label += ': ';
            if (context.parsed.y !== null) {
              label += formatCurrency(
                context.parsed.y / 100,
                'nl-NL',
                'currency',
                'EUR'
              );
            }
            return label;
          },
        },
      },
    },

    scales: {
      y: {
        stacked: true,
        ticks: {
          callback: function (value) {
            return formatCurrency(
              value / 100,
              'nl-NL',
              'currency',
              'EUR'
            );
          },
        },
      },
      x: {
        stacked: true,
      },
    },
  }), [isMobile]);

  return <Bar options={options} data={data} />;
}
